// react and js

// mui

// components

// hooks

// layouts

// pages

// theme

// utils

// widgets

// ----------------------------------------------------------------------
// Code
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// Properties
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// Main element export(s)
// ----------------------------------------------------------------------
// Default local settings values (OBFUSCATED!)
export const myLocalSettingStorage = {
  // Page: account_settings
  // ...

  // Page: subscriptions
  // ...

  // Page: downloads
  obfs203515b7ac68d72a: 0, // Clear: downloadApplicationVersion
  obfs4935af76d5753ad6: 0, // Clear: downloadTickDataSymbol

  // Page: accounting
  obfsa1d78ea6c9cbdd85: false, // Clear: accountingInvoicesTableFilterCollapse
  obfs049620f0953ec14a: 10, // Clear: accountingInvoicesTableFilterItemsPerPage
  obfs096db587116cc1b1: "", // Clear: accountingInvoicesTableFilterId
  obfsb8477d8d7dabcef1: "", // Clear: accountingInvoicesTableFilterDate
  obfs1842ca6643e81b58: "", // Clear: accountingInvoicesTableFilterProduct
  obfs2601c6855dfd60a8: "", // Clear: accountingInvoicesTableFilterAmount

  // Page: distributor_portal
  obfs02964be666064015: 0, // Clear: distributorPortalDistributor
  obfsc8dba69ffc954db5: 0, // Clear: distributorPortalRevenueCommissionPeriod
  obfs9125e01e3d862e2e: 0, // Clear: distributorPortalAvailablePlans
  obfs67750d1b034e81c6: 0, // Clear: distributorPortalAvailableTickDataPlans
  obfscc67442277b56b01: false, // Clear: distributorPortalAvailableTickDataPlansCollapse
  obfsd043b7a5866a81b2: "3_0", // Clear: distributorPortalDistributionApplicationLimitationsVersion
  obfs4bebfc736e2f169f: 0, // Clear: distributorPortalDistributionApplicationLimitationsApplication
  //
  obfsee608a5915392cd7: false, // Clear: distributorPortalApplicationCustomersTableFilterCollapse
  obfs4c600de4f4f0573b: 3, // Clear: distributorPortalApplicationCustomersTableFilterItemsPerPage
  obfs56152826f5e79efa: "", // Clear: distributorPortalApplicationCustomersTableFilterId
  obfse81f2b9b35f6c1ee: "", // Clear: distributorPortalApplicationCustomersTableFilterForename
  obfsc539eee8491fc3e4: "", // Clear: distributorPortalApplicationCustomersTableFilterSurname
  obfs3b11728390a578a5: "", // Clear: distributorPortalApplicationCustomersTableFilterEmail
  obfs0f54405943bd0fb8: "", // Clear: distributorPortalApplicationCustomersTableFilterCountry
  //
  obfs58ba9f5b3dcba6b8: false, // Clear: distributorPortalTickDataCustomersTableFilterCollapse
  obfsf5da3a01c268f44f: 3, // Clear: distributorPortalTickDataCustomersTableFilterItemsPerPage
  obfsdef96eac893350d4: "", // Clear: distributorPortalTickDataCustomersTableFilterId
  obfsb527ce61f771e6bd: "", // Clear: distributorPortalTickDataCustomersTableFilterForename
  obfs02749bbdae439090: "", // Clear: distributorPortalTickDataCustomersTableFilterSurname
  obfs45d87d82ab47e8bd: "", // Clear: distributorPortalTickDataCustomersTableFilterEmail
  obfs18894a63ab319423: "", // Clear: distributorPortalTickDataCustomersTableFilterCountry
  //
  obfs5e703cefbe0a57a2: false, // Clear: distributorPortalDistributionApplicationInvoicesTableFilterCollapse
  obfs2e50f66cd66f4baa: 3, // Clear: distributorPortalDistributionApplicationInvoicesTableFilterItemsPerPage
  obfs87d49b0e01d07f47: "", // Clear: distributorPortalDistributionApplicationInvoicesTableFilterId
  obfs362883a2a0b07b7a: "", // Clear: distributorPortalDistributionApplicationInvoicesTableFilterDate
  obfs3dd8ea76e3692868: "", // Clear: distributorPortalDistributionApplicationInvoicesTableFilterProduct
  obfs53ad8797135dd313: "", // Clear: distributorPortalDistributionApplicationInvoicesTableFilterAmount
  //
  obfs96854d3129b87ed0: false, // Clear: distributorPortalDistributionTickDataInvoicesTableFilterCollapse
  obfs082651ab4c5d253a: 3, // Clear: distributorPortalDistributionTickDataInvoicesTableFilterItemsPerPage
  obfs235a4a7bf7ebefb4: "", // Clear: distributorPortalDistributionTickDataInvoicesTableFilterId
  obfsa54285f5418f87d0: "", // Clear: distributorPortalDistributionTickDataInvoicesTableFilterDate
  obfsd9d6a55cbb2ffc59: "", // Clear: distributorPortalDistributionTickDataInvoicesTableFilterProduct
  obfs71166139d97e4623: "", // Clear: distributorPortalDistributionTickDataInvoicesTableFilterAmount

  // Page: evaluation_portal
  obfsc1f7fcfaa4896859: false, // Clear: evaluationPortalTableFilterCollapse
  obfscbdd0930afb23b49: 3, // Clear: evaluationPortalTableFilterItemsPerPage
  obfs21e0919001c115ad: "", // Clear: evaluationPortalTableFilterId
  obfs7c4d8a1f9e3b250a: "", // Clear: evaluationPortalTableFilterDashboardId
  obfs6e2a3b8d1f9c4705: "", // Clear: evaluationPortalTableFilterProductId
  obfsf89d594e2078650c: "", // Clear: evaluationPortalTableFilterAccountNumber
  obfs545d251b417763e1: "", // Clear: evaluationPortalTableFilterTradingServer

  // Page: application_settings
  obfsc3bf8f9d4ed9afbe: false, // Clear: applicationSettingsPrivateApplicationSettingsTableFilterCollapse
  obfsd913338dd282e0c8: 50, // Clear: applicationSettingsPrivateApplicationSettingsTableFilterItemsPerPage
  obfs772f1a80dd99905e: "", // Clear: applicationSettingsPrivateApplicationSettingsTableFilterId
  obfs4dc7dcdff571f6b0: "", // Clear: applicationSettingsPrivateApplicationSettingsTableFilterProductId
  obfsa05d5c5342ed08df: "", // Clear: applicationSettingsPrivateApplicationSettingsTableFilterUserIdendifier
  obfsba82f5913005101c: "", // Clear: applicationSettingsPrivateApplicationSettingsTableFilterPlanId
  obfs93b1f3c9fe678b8d: "", // Clear: applicationSettingsPrivateApplicationSettingsTableFilterBrokerId
  obfs3e9e9f34f5414730: "", // Clear: applicationSettingsPrivateApplicationSettingsTableFilterValue
  //
  obfsaef18eb5e60a8c61: false, // Clear: applicationSettingsPublicApplicationSettingsTableFilterCollapse
  obfsb2f73d3a058209ea: 50, // Clear: applicationSettingsPublicApplicationSettingsTableFilterItemsPerPage
  obfs33628e6db9542c05: "", // Clear: applicationSettingsPublicApplicationSettingsTableFilterId
  obfs6332e0ca833e5390: "", // Clear: applicationSettingsPublicApplicationSettingsTableFilterProductId
  obfs141fae1ceccdfc6d: "", // Clear: applicationSettingsPublicApplicationSettingsTableFilterPlanId
  obfse44b33540c0d7849: "", // Clear: applicationSettingsPublicApplicationSettingsTableFilterBrokerId
  obfs7bbe3154cb531b61: "", // Clear: applicationSettingsPublicApplicationSettingsTableFilterValue
};
